import React from "react";
import {connect} from "dva";
import {utils_tool, component_tool, framework_tool} from "@/tool";
import './applyLook.less'
import moment from "moment";

let {Session, getPageData} = utils_tool
const {
  WizButton,
  WizCard,
  WizRow,
  WizCol,
  WizModal,
  WizSpin,
  WizTable,
  WizTabs,
  WizSearchBar,
  WizDataTable
} = component_tool;
const {TabPane} = WizTabs;
const {WizContainer, modelUtils} = framework_tool;
import createColumns from "./columns"
import {AudienceGroupItem} from '@/components';

const getParamRecord = (history) => {
  let record = {}
    if (history.location.record) {
      record = history.location.record
      Session.set('ApplyInfo', record)
    } else {
      record = Session.get('ApplyInfo') || {}
    }
  return record
}

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

class applyLook extends WizContainer {

  componentName = "applyLook";

  constructor(props) {
    super(props)
    let {history} = props
    let pathname = '/workflow/apply'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/applyPerm')) {
      pathname = '/perm/applyPerm'
    }
    this.pathname = pathname
    let record = getParamRecord(history)
    this.state = {
      record: record,
      id: record.id,
      rows: [],
      selectedRows: 0,
      planList: [],
    }
  }

  returnTime = (startTime, endTime) => {
    return moment(startTime).format("YYYY-MM-DD HH:mm") + " ~ " + moment(endTime).format("YYYY-MM-DD HH:mm")
  }

  /**
   * 报名信息卡片界面（上半部分）
   */
  returnApplyInfo = () => {
    const returnTime = this.returnTime
    let applyStatus = "";
    let applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#FFFFFF', backgroundColor: '#BEBEBE'};
    switch (this.state.record.status) {
      case 1:
        applyStatus = "已发布";
        applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#008B00', backgroundColor: '#B4EEB4'};
        break;
      case 2:
        applyStatus = "已取消";
        break;
      case 3:
        applyStatus = "已关闭";
        break;
      default:
        applyStatus = "草稿";
        break;
    }
    let enrollWay = "";
    switch (this.state.record.enrollWay) {
      case 0:
        enrollWay = "站内管理员报名";
        break;
      case 1:
        enrollWay = "学员报名";
        break;
    }
    let planType = "";
    switch (this.state.record.planType) {
      case 0:
        planType = "公共"
        break;
      case 1:
        planType = "班级";
        break;
      // case 2:
      //   planType = "活动";
      //   break;
    }
    let infoType = "";
    switch (this.state.record.infoType) {
      case 0:
        infoType = "无";
        break;
      case 1:
        infoType = "文字信息";
        break;
      case 2:
        infoType = "问卷收集";
        break;
    }

    const arr = [
      {label: '报名名称：', value: this.state.record.name},
      {label: '报名时间：', value: returnTime(this.state.record.startTime, this.state.record.endTime)},
      {label: '报名方式：', value: enrollWay},
      {label: '安排类型：', value: planType},
      {label: '信息收集：', value: infoType}
    ]

    return arr.map((val, index) => {
      return (
        <WizRow key={val.label} type="flex" gutter={[5, 16]}>
          <WizCol span={5} md={3} xs={8} style={{textAlign: 'right'}}>{val.label}</WizCol>
          {index ?
            <WizCol span={19} md={21} xs={16}>
              <div className='applyRecordInfo-discriptions'>{val.value}</div>
            </WizCol>
            :
            <WizCol span={19} md={21} xs={16}>
              {val.value}
              <span style={applyStatusColor}>{applyStatus}</span>
            </WizCol>
          }
        </WizRow>
      )
    })
  }

  _componentDidMount() {
    this._getTargetScopeInfo();
    let {record, id} = this.state
    if (record && record.planIds) {
      this._getPlanList(record.planIds, id)
    }
  }

  propsAndStateOnChange = {
    surveyInfo: this._surveyInfo.bind(this),
    planList: this._getPlanListOver.bind(this),
  }

  _getPlanListOver(nextProps, nextState) {
    if (nextProps.planList.code === 1) {
      nextState.planList = nextProps.planList.data
    }
    return true;
  }

  _getPlanList(planIds, id) {
    this.doAction(
      {
        path: 'applyPlan/list',
        payload: {
          key: 'planListByCond',
          apiParams: {
            ids: planIds,
            applyId: id
          }
        }
      }
    )
  }

  _getTargetScopeInfo() {
    let {record} = this.state
    this.doAction({
      path: 'applyTargetScopeInfo/targetScopeInfo',
      payload: {
        key: 'apply@targetScopeInfo',
        apiParams: {id: record['id']}
      },
    })
  }

  _getAuthInfo() {
    let {record} = this.state
    this.doAction({
      path: 'applyGetApplyInfo/getApplyInfo',
      payload: {
        key: 'apply@authInfo',
        apiParams: {id: record['id']}
      },
    })
  }

  _getRecordPageList(apiParams = {}) {
    let {record} = this.state
    this.doAction({
      path: 'applyRecordPageList/recordPageList',
      payload: {
        key: 'apply@recordPageList',
        apiParams: {
          applyId: record['id'],
          current: 1,
          size: 10,
          ...apiParams
        }
      },
    })
  }

  _getValue = (type, key) => {
    const values = {
      type: {
        0: "公共",
        1: "班级",
        //  2: "活动"
      },
      state: {
        0: '无效',
        1: '有效'
      }

    };
    return values[type][key]
  };

  renderAuthInfo = () => {
    let {authInfo, applyGetApplyInfoLoading} = this.props;
    let data = []
    if (authInfo && authInfo['success']) {
      data = authInfo['data']['plans'] || []
    }
    let _columns = () => {
      return [
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          name: "name",
        },
        {
          title: "计划安排类型",
          dataIndex: "type",
          key: "type",
          name: "type",
          render: (text) => {
            return this._getValue('type', text)
          }
        },
        {
          title: "计划安排时间",
          dataIndex: "applyPlanTime",
          key: "applyPlanTime",
          name: "applyPlanTime",
          render: (text, record) => {
            const {startTime, endTime} = record;
            return formatterDate(startTime) + " ~ " + formatterDate(endTime)
          }
        },
        {
          title: "地点",
          dataIndex: "address",
          key: "address",
          name: "address",
        },
        {
          title: "限制人数",
          dataIndex: "limitCount",
          key: "limitCount",
          name: "limitCount",
          render: (text, record) => {
            if (text < 0) {
              text = '不限制'
            }
            return text
          }
        },
        {
          title: "报名人数",
          dataIndex: "applyNumber",
          key: "applyNumber",
          name: "applyNumber",
        },
        {
          title: "通过人数",
          dataIndex: "passNumber",
          key: "passNumber",
          name: "passNumber",
        },
        {
          title: '安排状态',
          dataIndex: 'state',
          key: 'state',
          name: 'state',
          render: (text) => {
            return this._getValue('state', text)
          }
        }
      ]
    }

    return (
      <WizSpin tip={'加载中'} spinning={applyGetApplyInfoLoading}>
        <WizTable columns={_columns()} dataSource={data} pagination={false}/>
      </WizSpin>
    )
  }

  _onSelect(keys, rows) {
    let selectData = [];
    rows && rows.forEach(e => {
      if (e && e.id) {
        let id = e.id
        let status = e.status
        let selectInfos = {id, status}
        selectData.push(selectInfos)
      }
    })
    this.setState({
      keys,
      rows,
      selectedRows: keys.length,
      selectData
    })
  }

  _onLook = (record) => {
    let {infoType} = this.state.record
    let r = []
    if (infoType === 1) {
      let visible = `look@${record['id']}`
      let _showModal = (f) => {
        this.setState({[visible]: f})
      }
      r.push(
        <WizDataTable.Oper>
          <WizButton tooltip="查看反馈信息" onClick={() => {
            _showModal(true)
          }}>
            查看反馈信息
          </WizButton>
          <WizModal
            key={visible}
            visible={this.state[visible]}
            title={'查看信息收集'}
            footer={null}
            onCancel={() => {
              _showModal(false)
            }}
          >
            <p>{record['recordInfo'] ? record['recordInfo'] : '暂无反馈信息'}</p>
          </WizModal>
        </WizDataTable.Oper>
      )
    } else if (infoType === 2) {
      if (record['recordInfo'] && record['recordInfo'] !== '') {
        let _surveyAnswerList = () => {
          if (!record['personId'] || record['personId'] === '') {
            wizNotice.error('学员信息有误,请稍后再试');
            return;
          }
          this.doAction({
            path: 'survey/findSurveyAnswerById',
            payload: {
              key: 'findSurveyAnswerById',
              apiParams: {
                id: record['recordInfo']
              }
            }
          })
        }
        r.push(
          <WizDataTable.Oper>
            <WizButton tooltip="查看反馈信息" onClick={() => {
              _surveyAnswerList()
            }}>
              查看反馈信息
            </WizButton>
          </WizDataTable.Oper>
        )
      }

    }
    r.push(
      <WizDataTable.Oper>
        <WizButton tooltip="查看任职" onClick={() => {
          this.jumpPage('push', this.pathname+'/applyInfo/lookPositionInfo', {...record, showAuthority: false});
        }}>
          查看任职
        </WizButton>
      </WizDataTable.Oper>
    )
    return r
  }

  renderRecordPageList = () => {
    let {recordPageList, applyRecordPageListLoading, surveyInfoLoading} = this.props;
    let {rows, record, planList} = this.state
    let planListInfo = []
    planList  && planList.length && planList.forEach(plan => {
      planListInfo.push({ code: plan.id, codeName: plan.name })
    })
    let columns = createColumns(this, planListInfo)
    let list = getPageData(recordPageList && recordPageList.data);
    let searchBarProps = {
      columns,
      onSearch: values => {
        this._getRecordPageList(values)
      }
    }
    let dataTableProps = {
      loading: applyRecordPageListLoading,
      columns,
      rowKey: "id",
      dataItems: list,
      showNum: false,
      selectType: "checkbox",
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this._getRecordPageList({current: pageNum, size: pageSize})
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={surveyInfoLoading}>
        <div className='pagination'>
          <WizSearchBar key="applyRecord_searchBar" type="grid" {...searchBarProps} />
        </div>
        <WizDataTable key={'applyRecord_dataTable'} {...dataTableProps}/>
        <div className='pagination'>
          <WizDataTable.Pagination key={'applyRecord_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  renderTargetScopeInfo = () => {
    let {targetScopeInfo, applyTargetScopeInfoLoading} = this.props;
    let initialValue = {
      groupId: null,
      isAll: null,
      orgIds: [],
      positionIds: [],
      positionCategoryIds: [],
      personIds: [],
      message: []
    }
    if (targetScopeInfo && targetScopeInfo['success']) {
      initialValue = targetScopeInfo['data'];
      initialValue['message'] = [`受众人数：${initialValue['scopeCount'] ? initialValue['scopeCount'] : 0}`, `提交人数：${initialValue['submitCount'] ? initialValue['submitCount'] : 0}`]

    }
    return (
      <WizSpin tip={'加载中'} spinning={applyTargetScopeInfoLoading}>
        {/* <WizAuthority value={initialValue} mode='Show' /> */}
        <AudienceGroupItem {...initialValue} />
      </WizSpin>
    )
  }

  changeTab = (e) => {
    if (e === '1') {
      this._getTargetScopeInfo()
    } else if (e === '2') {
      this._getAuthInfo()
    } else if (e === '3') {
      this._getRecordPageList()
    }
  }


  returnInfoTab = () => {
    return (
      <WizCard>
        <WizTabs defaultActiveKey="1" onChange={this.changeTab}>
          <TabPane tab="报名受众" key="1">
            {this.renderTargetScopeInfo()}
          </TabPane>
          <TabPane tab="计划安排列表" key="2">
            {this.renderAuthInfo()}
          </TabPane>
          <TabPane tab="学员报名列表" key="3">
            {this.renderRecordPageList()}
          </TabPane>
        </WizTabs>
      </WizCard>
    )
  }

  _surveyInfo(nextProps, nextState) {
    let {surveyInfo} = nextProps
    if (surveyInfo) {
      surveyInfo['success'] ?
        this.jumpPage('push', this.pathname+'/applyInfo/surveyRecordInfoDetail', surveyInfo['data']) :
        wizNotice.error(surveyInfo['msg']);
    } else {
      wizNotice.error('获取问卷信息失败,请稍后再试')
    }
    return true;
  }

  _render() {
    const returnApplyInfo = this.returnApplyInfo
    const returnInfoTab = this.returnInfoTab
    return (
      <>
        {
          <WizCard title={"报名信息"}>
            {this.returnApplyInfo()}
          </WizCard>
        }
        {
          returnInfoTab()
        }
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {applyRecordPageList, applyTargetScopeInfo, applyGetApplyInfo, survey, applyPlan} = state;
  const targetScopeInfo = modelUtils.getModelEntity(applyTargetScopeInfo, "apply@targetScopeInfo");
  const authInfo = modelUtils.getModelEntity(applyGetApplyInfo, "apply@authInfo");
  const recordPageList = modelUtils.getModelEntity(applyRecordPageList, "apply@recordPageList");
  const surveyInfo = modelUtils.getModelEntity(survey, 'findSurveyAnswerById')
  const planList = modelUtils.getModelEntity(applyPlan, "planListByCond");
  const load = modelUtils.getLoadingState(state, ['applyTargetScopeInfo', 'applyGetApplyInfo', 'applyRecordPageList', 'surveyInfo']);
  return {
    targetScopeInfo,
    authInfo,
    recordPageList,
    surveyInfo,
    planList,
    ...load
  }
};

export default connect(mapStateToProps)(applyLook);
